import {memo} from 'react';
import Select from 'react-select';
import { reactSelectType } from '../../../Utils/Const';
import { isDisabled } from '@testing-library/user-event/dist/utils';
import ReactTooltip from '../../ReactTooltip/ReactTooltip';
import { IconInfo, IconInfo1 } from '../../../assests/icons/DrawerIcons';
 
const ReactSelect = ({ id, labelname,name, options,noOptionsMessage,smpadding = false, placeholder = 'Select an option..', onChange, value, isMulti,
  filterOptions, closeMenuOnSelect = true, isUpload = false, icon, infoDetails, isrequired = false,disabled = false,error,pageSize=5,isSearchable=true,
  handleInputChange,isLoading,key,onFoucs,menuPlacement="auto",helperText,
  tooltipContent, ToolTipId,toolTipIcon, tooltipSide = "LSB", tooltipIcon = <IconInfo />,istooltipContent,
onIconBtnClick }: reactSelectType) => {
 
  return (
    <div className={`main-box1 group relative  ${smpadding ? "pt-1" : ""}`}  title={value?.label} >
        {labelname && <label className={`label-box1  ${error && "label-error"} !flex items-center `}>{labelname} {isrequired && <span className='text-rose-400 text-lg pl-0.5 leading-none '>*</span>}
        {tooltipContent && <span className="cursor-pointer flex-end ml-1" data-tooltip-id={`${name}Tooltip`}><IconInfo1 /></span>}
        </label>}
        <Select name={name}
          className={`select-element ${error ? 'select-error' : ''}`}
          styles={{
            control: (styles: any, { data, isDisabled, isFocused, isSelected }: any) => ({
              ...styles,
              //     display: 'inline-flex',
              //     border: 'none',
              // borderColor:isDisabled?"rgb(209 213 219 / 1)" : error &&  !disabled && 'rgb(251 113 133 / 1)',
              borderColor: error? 'rgb(251 113 133 / 1)' : isDisabled? "rgb(209 213 219 / 1)":  isFocused ? 'rgb(209 213 219 / 1)' : 'rgb(209 213 219 / 1)',
              borderRadius: '0.25rem',
              // zIndex: 2,
              cursor: isDisabled ? 'not-allowed!important' : 'default',
              pointerEvents: isDisabled ? 'auto' : 'inherit',
              width: '100%',
              fontSize:"1.4vh !important",
              // boxShadow: error && "0 0 1px rgb(251 113 133 / 1)",
              // backgroundColor:isDisabled?"rgb(229 231 235 / 1)":'rgb(255 255 255)',
              boxShadow: isFocused ? '0 0 0 1px rgb(156 163 175 / 1), 0 0 2px 1px rgb(209 213 219 / 1)' : error? "0 0 1px rgb(251 113 133 / 1)": 'none',
              backgroundColor: isDisabled?"rgb(229 231 235 / 1)":isFocused ? "rgb(249 250 251 / 1)":'rgb(255 255 255)',
              // whiteSpace:'nowrap',
              "&>div:first-child": {
              //   // flexWrap: 'nowrap',
              //   // overflowX: 'auto',
              //   width:"150px",
              //   "::-webkit-scrollbar": {
              //     display: 'none',
              //     },
                  "&>div": {
              //     minWidth: "fit-content",
              //     marginBottom:"-5px !important",
              // color: error &&  !disabled && 'rgb(251 113 133 / 1) !important',
              color: error  && 'rgb(251 113 133 / 1) !important',
                }
              },
              "&:hover": {
                outline: 'none',
              },
              "& input": {
                color: error && !disabled && 'rgb(251 113 133 / 1) !important',
                fontSize:'1.4vh !important'
              },
              "& input:focus": {
                // color:'red !important',
                border:'red',
                outline:'none !important'
              },
              "& svg": {
                color:error &&  !disabled && 'rgb(251 113 133 / 1)',
                // transition: 'all .3s',
                // cursor: 'pointer',
                // width:"20px",
                // outline:"2px",
                // display:'none'
              },
              "& svg:focus": {
                color: 'red !important',
              },
              "& span": {
                backgroundColor: error && !disabled &&'rgb(251 113 133 / 1)',
              }
            }),
            menu: (styles: any) => ({
              ...styles,
              fontSize:'1.4vh !important',
              //   overflow:"auto !important",
              //  maxHeight:"5vh !important"  ,

              // zIndex: 999,
              // position: 'absolute',
              // width: '100%',
              // padding: '0px',
              "& div::-webkit-scrollbar": {
                  width: '0.4vh',
                  height: '0.4vh'
              },
              "& div::-webkit-scrollbar-track":{
                background: '#fff'
              },
              "& div::-webkit-scrollbar-thumb":{
                borderRadius: '0.1vh',
                backgroundColor: 'transparent',
                backgroundImage: 'linear-gradient(to top, #c1c1c1 0, #c1c1c1 100%)'
              },
              "div":{
                overflow:"auto",
               maxHeight:"20vh"              }
            }),
          }}
          filterOption={filterOptions}
          onFocus={onFoucs}
          isMulti={isMulti}
          options={options}
          onChange={onChange}
          value={value}
          isSearchable={isSearchable}
          pageSize={pageSize}
          placeholder={placeholder}
          closeMenuOnSelect={closeMenuOnSelect}
          isDisabled={disabled}
          onInputChange={(inputValue:string,inputMeta:any)=>handleInputChange && handleInputChange(inputValue,name,inputMeta)}
          isLoading={isLoading}
          key={key}
          menuPlacement={menuPlacement}
          noOptionsMessage={(obj)=> noOptionsMessage ? <>{noOptionsMessage}</> : obj.inputValue?obj.inputValue:'No options'}
        />
        {/* {error && !disabled &&<span className="label-box1 label-error absolute -bottom-4">{error}</span>} */}
        {/* Error Message */}
        {error && (<span className="label-box1 label-error absolute -bottom-4"> {error}</span>)}
        
        {/* Helper Text (Always visible if no error and not empty) */}
        {!error && helperText && helperText.trim() !== '' && ( <span className="helper-box1 opacity-100 absolute -bottom-3">
            {helperText} </span>)}

        {tooltipContent && istooltipContent && <ReactTooltip isClickable Side={tooltipSide} place="right" id={`${name}Tooltip`} content={tooltipContent} />}
            
     </div> ); };
         
export default memo(ReactSelect);
 